import React, { useEffect, useState, useCallback } from 'react'; 
import ListReports from './list.jsx';
import { Spinner } from 'reactstrap';
import api from '../../services/client/api';
import cookie from '../../services/cookie/index';
import { deleteAllCookies, deleteCookies } from '../../utils/functions';
import { useHistory, useLocation } from 'react-router-dom';
import { faMicroscope,  faQuestionCircle,  faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NoExams from '../../components/NoExams/';
import RegisterOther from '../../components/RegisterOtherUser';
import {ButtonOther, LeftAlignedTextBlock} from './styles';
export default function Reports() {
  const [reportsByPatient, setReportsByPatient] = useState({});
  const [reportsByDependents, setReportsByDependents] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const history = useHistory();
  const location = useLocation();
  const [hasFetchedReports, setHasFetchedReports] = useState(false);
  const token = cookie().get('token'); // Recupera o token do cookie
  const username = cookie().get('username');
  const [timeoutPassed, setTimeoutPassed] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const handleOpenRegisterModal = () => {
        setShowRegisterModal(true);
    };
    const handleCloseRegisterModal = () => {
        setShowRegisterModal(false);
    };
    


  const getDateToday = () => {
    let date = new Date();
    date.getFullMonth = function () {
      let month = this.getMonth() + 1;
      return month > 9 ? month : '0' + month;
    };
    date.getFullDay = function () {
      let day = this.getDate();
      return day > 9 ? day : '0' + day;
    };
    return date.getFullYear() + '-' + date.getFullMonth() + '-' + date.getFullDay();
  };
  const getReports = useCallback(async () => {

    // Verificação rigorosa dos valores
  
    try {
      const response = await api().report().getAll(token, '1900-01-01', getDateToday());

      if (response.status === 401) {
        await deleteCookies();
        return history.replace({ pathname: '/login' });
      }
  
      if (response.status === 200) {
        // Agrupar exames por categoria

        const groupedReportsByCategory1 = {};
        const groupedReportsByCategory2 = {};

        // Iterando sobre os exames retornados
        response.output.forEach(report => {
    
          // Agrupando por categoria 1
          if (report.id_categoria === 1) {
            if (!groupedReportsByCategory1[report.id_patient]) {
              groupedReportsByCategory1[report.id_patient] = { patientName: report.patient, exams: [] };
            }
            groupedReportsByCategory1[report.id_patient].exams.push(report);
          }
  
          // Agrupando por categoria 2
          if (report.id_categoria === 2) {
            if (!groupedReportsByCategory2[report.id_patient]) {
              groupedReportsByCategory2[report.id_patient] = { patientName: report.patient, exams: [] };
            }
            groupedReportsByCategory2[report.id_patient].exams.push(report);
          }
        });
  
        setReportsByPatient(groupedReportsByCategory1);
        setReportsByDependents(groupedReportsByCategory2);
        setIsLoading(false);
        setErrorMessage(''); 

      }else if (response.status === 404) {
        setErrorMessage('error'); 
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Erro ao obter os exames:', error);  // Captura de erro adicional
      setErrorMessage('Ocorreu um erro ao carregar os exames. Tente novamente mais tarde.');
      setIsLoading(false);
    }
  },  [history, token]);
  

  useEffect(() => {
    if (!hasFetchedReports && username) {
      getReports();
      setHasFetchedReports(true);
    }
  
    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [hasFetchedReports, username, location, history, getReports]);
  

  
  useEffect(() => {
    let timer;

    if (isLoading) {
      timer = setTimeout(() => {
        setTimeoutPassed(true);
      }, 35000); // 35 segundos
    }

    // Limpeza se o loading terminar antes dos 30s
    return () => {
      clearTimeout(timer);
    };
  }, [isLoading]);

  useEffect(() => {
    if (timeoutPassed) {
      // ação após 30s de loading — exemplo: redirecionar para login
      deleteAllCookies()
      history.replace('/login');
    }
  }, [timeoutPassed, history]);

return (
  <div>
    {/* Condição para exibir o título apenas quando não houver erro */}
    {!errorMessage && (
      <h1>
        <FontAwesomeIcon icon={faMicroscope} /> Meus Exames
      </h1>
    )}

    {isLoading ? (
      <div>
        <Spinner color="primary" /> Carregando...
      </div>
    ) : errorMessage ? (
      <div>
        <NoExams cpf={username} />
      </div>
    ) : (
      <>
        {/* Exibindo os exames da categoria 1 */}
        {Object.entries(reportsByPatient).length > 0 && (
          <div>
            {Object.entries(reportsByPatient).map(([idPatient, { patientName, exams }]) => (
              <div key={idPatient}>
                <ListReports
                  key={idPatient}
                  reports={exams}
                  token={token}
                  username={username}
                />
                <hr />
              </div>
            ))}
          </div>
        )}

        {/* Exibindo os exames da categoria 2 */}
        {Object.entries(reportsByDependents).length > 0 && (
          <div>
            <h4 style={{ color: '#0C2B6E', fontWeight: 650 }}>
              <FontAwesomeIcon icon={faUsers} style={{ marginRight: 5 }} />Exames de Dependentes
            </h4>
           {Object.entries(reportsByDependents).map(([idPatient, { patientName, exams }]) => (
            <div key={idPatient}>
              <ListReports
                key={idPatient}
                reports={exams}
                token={token}
                username={username}
              />
              <hr />
            </div>
          ))}

          </div>
          
        )}
    <>
    
      <LeftAlignedTextBlock>
       <h4 style={{ color: '#0c2b6eee', fontWeight: 650 }}>  <FontAwesomeIcon icon={faQuestionCircle} style={{ marginRight: '2px' }} />Acessar exames de dependentes ou terceiros:</h4>

        <p>
          Seu acesso como paciente foi realizado com sucesso. Agora, se você também precisa consultar exames de um dependente ou de um paciente pelo qual é responsável legal, é necessário realizar uma solicitação adicional.
        </p>
        <p>
          Para garantir a segurança e a privacidade das informações, pediremos os dados do paciente e o envio de um documento de autorização (procuração).
        </p>
        <p>
          Clique no botão abaixo para iniciar a solicitação de acesso como responsável legal.
        </p>
      </LeftAlignedTextBlock>

      {showRegisterModal && <RegisterOther onClose={handleCloseRegisterModal} />}

      <ButtonOther onClick={handleOpenRegisterModal}>
        Solicitar Acesso como Responsável Legal
        <FontAwesomeIcon icon={faUsers} style={{ marginLeft: '10px' }} />
      </ButtonOther>
    </>
      </>
    )}
  </div>
);
}
